/** Matches `MM/YYYY` used in inquiry list URL params and the backend filter. */
export const MMYYYY_REGEX = /^(0?[1-9]|1[0-2])\/(\d{4})$/;

const ISO_MONTH = /^(\d{4})-(\d{2})$/;

/** `MM/YYYY` from URL → `YYYY-MM` for `<input type="month">`. */
export function mmyyyyToMonthInput(value: string | undefined): string {
  if (!value?.trim()) {
    return "";
  }
  const match = value.trim().match(MMYYYY_REGEX);
  if (!match) {
    return "";
  }
  const month = match[1].padStart(2, "0");
  const year = match[2];
  return `${year}-${month}`;
}

/** `YYYY-MM` from month input → `MM/YYYY` for API. */
export function monthInputValueToMMYYYY(value: string): string | undefined {
  const v = value?.trim();
  if (!v) {
    return undefined;
  }
  const match = v.match(ISO_MONTH);
  if (!match) {
    return undefined;
  }
  const year = match[1];
  const monthNum = parseInt(match[2], 10);
  if (monthNum < 1 || monthNum > 12) {
    return undefined;
  }
  return `${String(monthNum).padStart(2, "0")}/${year}`;
}

export function utcFirstOfMonthFromMMYYYY(mmyyyy: string): number {
  const match = mmyyyy.match(MMYYYY_REGEX);
  if (!match) {
    return NaN;
  }
  const month = parseInt(match[1], 10) - 1;
  const year = parseInt(match[2], 10);
  return Date.UTC(year, month, 1);
}
